import axios from "axios";
import { Base_URL } from "../url";

export const saveUserAttendance = async (attendanceData) => {
  try {
    console.log(attendanceData, "attendanceData");
    const response = await axios.post(`${Base_URL}/SalaryProcess/UserAttendence`, attendanceData);
    return response.data;
  } catch (error) {
       console.error("API Error:", error);

    if (error.response) {
      throw (
        error.response.data || {
          message: "Server error occurred.",
        }
      );
    }

    if (error.request) {
      throw {
        message: "No response from server. Please try again.",
      };
    }

    throw {
      message: error.message || "Unexpected error occurred.",
    };
  }
};

// Updated to fetch complete Working Days records
export const fetchWorkingDaysData = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/SalaryProcess/Working_DaysMaster/id?id=${id}`);
    return response.data;
  } catch (error) {
   console.error("API Error:", error);

    if (error.response) {
      throw (
        error.response.data || {
          message: "Server error occurred.",
        }
      );
    }

    if (error.request) {
      throw {
        message: "No response from server. Please try again.",
      };
    }

    throw {
      message: error.message || "Unexpected error occurred.",
    };
  }
};


// Updated to fetch complete Resource records
export const fetchResourceData = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/SalaryProcess/ResourceMasters/${id}`);
    return response.data;
  } catch (error) {
      console.error("API Error:", error);

    if (error.response) {
      throw (
        error.response.data || {
          message: "Server error occurred.",
        }
      );
    }

    if (error.request) {
      throw {
        message: "No response from server. Please try again.",
      };
    }

    throw {
      message: error.message || "Unexpected error occurred.",
    };
  }
};

/*import axios from "axios";
import { Base_URL } from "../url";

export const saveUserAttendance = async (attendanceData) => {
  try {
    const response = await axios.post(`${Base_URL}/UserAttendance`, attendanceData);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving attendance!";
  }
};

export const fetchWorkingDaysIds = async () => {
  try {
    const response = await axios.get(`${Base_URL}/UserAttendance/GetWorkingDaysIds`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching working days IDs!";
  }
};

export const fetchResourceIds = async () => {
  try {
    const response = await axios.get(`${Base_URL}/UserAttendance/GetResourceIds`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching resource IDs!";
  }
};*/